import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaCalendarCheck } from 'react-icons/fa';
import '../../../assets/css/customer/services/ActionSection.css';

const EventPlanningCTA = () => {
  return (
    <section className="event-planning-cta-section">
      <Container>
        <Row className="align-items-center">
          
          {/* Left Side - Content */}
          <Col xs={12} lg={6} className="mb-5 mb-lg-0">
            <div className="event-cta-content">
              
              {/* Decorative Icon */}
              <div className="event-cta-decorative-icon">
                <span className="stripe-pattern"></span>
              </div>

              {/* Subtitle */}
              <p className="event-cta-subtitle">
                Dedicated Wedding Planners
              </p>

              {/* Main Heading */}
              <h2 className="event-cta-main-heading">
                Let's Plan Your Next Event
              </h2>

              {/* Description */}
              <p className="event-cta-description">
                Whether you're planning a corporate event, a social gathering, or a wedding, let Bridely be your partner in creating unforgettable memories. Contact us today to schedule a consultation and start planning your next event!
              </p>

              {/* CTA Button */}
              <Button 
                variant="primary" 
                className="event-cta-button"
              >
                <FaCalendarCheck className="button-icon" />
                Make Reservations
              </Button>

            </div>
          </Col>

          {/* Right Side - Image */}
          <Col xs={12} lg={6}>
            <div className="event-cta-image-wrapper">
              {/* Background Shape */}
              <div className="event-cta-bg-shape"></div>
              
              {/* Couple Image */}
              <div className="event-cta-image-container">
                <img 
                  src="https://i.pinimg.com/736x/a0/55/cb/a055cb62d1ff3b355e60f46c71a53a4d.jpg"
                  alt="Wedding Couple" 
                  className="event-cta-image"
                  onError={(e) => {
                    e.target.src = 'https://images.unsplash.com/photo-1519741497674-611481863552?w=600&h=800&fit=crop';
                  }}
                />
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default EventPlanningCTA;